var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfAssessmentFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2713_2655)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.66 14.604c1.184 0 2.144.992 2.144 2.217s-.96 2.218-2.144 2.218c-1.184 0-2.144-.993-2.144-2.218s.96-2.218 2.144-2.218z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9 12.006c2.462.129 4.42 2.236 4.42 4.815l-.006.248a4.89 4.89 0 01-1.156 2.935l2.632 2.723.05.06a.75.75 0 01-1.072 1.036l-.056-.053-2.696-2.79a4.519 4.519 0 01-2.356.663l-.24-.007c-2.383-.125-4.293-2.101-4.414-4.567L13 16.821C13 14.16 15.087 12 17.66 12l.24.006zm-.24 1.494c-1.697 0-3.16 1.438-3.16 3.321 0 1.883 1.463 3.322 3.16 3.322s3.16-1.44 3.16-3.322c0-1.882-1.463-3.32-3.16-3.321z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.655 13.139a6.423 6.423 0 00-1.155 3.683c0 1.588.577 3.057 1.537 4.178H3.912c-.552 0-.99-.448-.9-.993C3.36 17.89 4.93 13.125 12 13.125c.224 0 .442.004.655.014zM12 3c2.51 0 4.544 2.015 4.544 4.5S14.51 12 12 12 7.456 9.985 7.456 7.5 9.49 3 12 3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2713_2655"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
SvgSelfAssessmentFilled.displayName = 'SelfAssessmentFilled';
export default SvgSelfAssessmentFilled;